<template>
    <div class="container" element-loading-text="加载中, 请稍后..."
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
<!--        <AMap v-show="twoOrThree" ref="map"-->
<!--              :center="center" :zoom="zoom"-->
<!--              @complete="complete" :loading.sync="mapLoading"></AMap>-->
      <div class="leftSider">
        <img src="@assets/leftSider.png" alt="">
      </div>
      <div class="rightSider">
        <img src="@assets/rightSider.png" alt="">
      </div>
        <dp-three-map  :key="threeMapKey"
                      ref="threeMap" :newMapData="newMapData" :mapList="mapList" :params="params" v-if=" activeScreen == 'general' && btnVal == '3D'">
        </dp-three-map>
        <ThreatMask v-if="threatMaskShow" @showThreatInfo="showThreatInfo"></ThreatMask>
        <dp-header :activeScreen="activeScreen"></dp-header>
        <DpCount :activeScreen="activeScreen" :chatShow="chatShow" ref="dpCountRef" @jumpChatEmit="jumpChatEmit"></DpCount>
        <DpLayout v-if="!showChat" ref="layout" :layout="layout"></DpLayout>
        <dp-chat :chatValue="chatValue" v-if="showChat" @close="closeChat"></dp-chat>
        <navigation v-if="!showChat" ref="nav" :disabled="mapLoading" @navChange="navChange"></navigation>
        <button-list v-if="activeScreen == 'general' || activeScreen == 'asset'" @btnListVal="btnListVal" :activeScreen="activeScreen" ></button-list>
        <button-switching v-if="activeScreen == 'general'" :btnVal="btnVal" @btnChange="btnChange"></button-switching>
      <map-data v-if="activeScreen == 'asset'" :btnListValue="btnListValue"></map-data>
      <world-map-data v-if="activeScreen == 'action'" :activeScreen="activeScreen"></world-map-data>
      <general-world-map-data ref="worldMapDataRef" v-if="activeScreen == 'general' && btnVal == '2D'" :activeScreen="activeScreen" :btnListValue="btnListValue"></general-world-map-data>
<!--      <china-map v-if="activeScreen == 'asset'"></china-map>-->
    </div>
</template>

<script>
import {Loading} from "element-ui";
import store from "@/store";
import {mapActions} from "vuex";
let loading = Loading.service({
  body: true,
  text: "加载中, 请稍后...",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.9)"
});

export default {
  name: "index",
  data() {
    return {
      showChat: false,
      chatShow: true,
      chatValue: "",
      btnListValue:"",
      threatMaskShow: false,
      mapLoading: false,
      twoOrThree: true,
      newMapData: [],
      mapList: [],
      btnVal:"3D",
      threeMapKey: Number(new Date()),
      center: [104.114129, 36.550339],
      zoom: 4.7,
      layout: {},
      params: {
        threat_level: "54321",
        statistics_type: "general",
        aggregation: "",
        secret: "",
        status: "",
        area_code: "",
        ip: "",
        organization_id: "",
        start_time: "",
        end_time: "",
        industry_miit_code: "",
        region: ""
      },
      activeScreen: "general",
      platformDict: [
        {
          name: "modules1",
          render: "chartOne"
        },
        {
          name: "modules2",
          render: "chartTwo"
        },
        {
          name: "modules3",
          render: "chartThree"
        },
        {
          name: "modules4",
          render: "chartFour"
        },
        {
          name: "modules5",
          render: "chartFive"
        }
      ],
      threatDict: [
        {
          name: "modules11",
          render: "newAttackMethod"
        },
        {
          name: "modules12",
          render: "effectedInstitutionThreat"
        },
        {
          name: "modules13",
          render: "effectedCountryDistribution"
        },
        {
          name: "modules14",
          render: "mov"
        }
      ],
      assetRelationDict: [
        {
          name: "modules21",
          render: "vulDetectionTrend"
        },
        {
          name: "modules22",
          render: "vulReportStatusTable"
        },
        {
          name: "modules23",
          render: "recentAlarmEvent"
        }
      ],
      actionDict: [
        {
          name: "modules31",
          render: "countryViewSafetyDeploy"
        },
        {
          name: "modules32",
          render: "dnssecDeploy"
        },
        {
          name: "modules33",
          render: "dotDeploy"
        },
        {
          name: "modules34",
          render: "dohDeploy"
        }
      ],
      askDict: [
        {
          name: "modules35",
          render: "knowledgeGraphDataSources"
        },
        {
          name: "modules36",
          render: "ontologyStructureKnowledgeGraph"
        },
        {
          name: "modules37",
          render: "newVulnerabilityList"
        }
      ]
    };
  },
  watch: {
    btnVal(newVal) {
      if (newVal === "2D") {
        this.$nextTick(() => {
          this.$refs.worldMapDataRef.getData();
        });
      }
    }
  },
  created() {
    this.getTypeDict();
    this.initLayout();
  },
  mounted() {
    setTimeout(() => {
      this.complete();
    },500);
  },
  methods: {
    ...mapActions("dict", ["getTypeDict"]),
    complete() {
      loading.close();
    },
    initLayout() {
      this.layout = {
        leftSideNum: 3,
        components: this.platformDict
      };
    },
    btnListVal(value){
      this.btnListValue = value;
    },
    navChange(value) {
      if (value !== "threat") {
        this.threatMaskShow = false;
      }
      if (value === this.activeScreen) {
        return;
      }
      this.btnVal = "3D";
      // this.activeScreen = value;
      if (value === "general") {
        this.threatMaskShow = false;
        this.activeScreen = value;
        this.initLayout();

      }
      if (value === "threat") {
        this.threatMaskShow = true;
        // this.layout = {
        //     leftSideNum: 3,
        //     components: this.threatDict
        // };
      }
      if (value === "asset") {
        this.threatMaskShow = false;
        this.activeScreen = value;
        this.layout = {
          leftSideNum: 2,
          components: this.assetRelationDict
        };

      }
      if (value === "action") {
        this.threatMaskShow = false;
        this.activeScreen = value;
        this.layout = {
          leftSideNum: 1,
          components: this.actionDict
        };
      }
      if (value === "ask") {
        this.threatMaskShow = false;
        this.chatShow = true;
        this.activeScreen = value;
        this.layout = {
          leftSideNum: 4,
          components: this.askDict
        };
      }
    },
    btnChange(val){
      if (val == "2D"){
        this.btnVal = "2D";
      }
      if (val == "3D"){
        this.btnVal = "3D";
      }

      if (val == "back"){
        this.btnVal = "2D";
        setTimeout(() => {
          this.btnVal = "3D";
        },0);
      }
    },
    showThreatInfo() {
      this.threatMaskShow = false;
      this.activeScreen = "threat";
      this.layout = {
        leftSideNum: 3,
        components: this.threatDict
      };
    },
    jumpChatEmit(val) {
      this.showChat = true;
      this.chatShow = false;
      this.chatValue = val;
    },
    closeChat() {
      this.$refs.dpCountRef.searchInput = "";
      this.showChat = false;
      this.chatShow = true;
      this.navChange("ask");
      this.chatValue = "";
    }
  }
};
</script>

<style lang="less">
.container {
    width: 100%;
    height: 100vh;
    background: url("../../assets/background.png") no-repeat #000;
    background-size:110% ;
}
button-list{
  z-index:9999;
}
#modules1 {
    top: 227px;
    left: 70px;
    width: 430px;
    height: 247px;
   transform-origin:left;
   transition: 1s;
}
.transformLeft{
  transform:skew(0,3deg) rotate3d(0, 1, 0, 15deg);
}
.transformRight{
  transform:skew(0,-3deg) rotate3d(0, 1, 0, 15deg);
}
#modules2 {
    top: 497px;
    left: 70px;
    width: 430px;
    height: 247px;
    transform-origin:left;
    transition: 1s;
}

#modules3 {
    top: 767px;
    left: 70px;
    width: 430px;
    height: 247px;
    transform-origin:left;
    transition: 1s;
}

#modules4 {
    top: 227px;
    left: 1420px;
    width: 430px;
    height: 422px;
    transform-origin:right;
    transition: 1s;
}

#modules5 {
    top: 672px;
    left: 1420px;
    width: 430px;
    height: 342px;
    transform-origin:right;
    transition: 1s;
}
#modules11 {
    top: 227px;
    left: 71px;
    width: 442px;
    height: 245px;
}

#modules12 {
    top: 495px;
    left: 71px;
    width: 442px;
    height: 245px;
}

#modules13 {
    top: 763px;
    left: 71px;
    width: 442px;
    height: 252px;
}
#modules14 {
    top: 227px;
    left: 572px;
    width: 1268px;
    height: 700px;
}
#modules21 {
    top: 228px;
    left: 70px;
    width: 430px;
    height: 299px;
}

#modules22 {
    top: 575px;
    left: 70px;
    width: 430px;
    height: 441px;
}

#modules23 {
    top: 228px;
    left: 1419px;
    width: 430px;
    height: 788px;
}
#modules31 {
    top: 228px;
    left: 70px;
    width: 430px;
    height: 787px;
}

#modules32 {
    top: 227px;
    left: 1420px;
    width: 430px;
    height: 247px;
}

#modules33 {
    top: 497px;
    left: 1420px;
    width: 430px;
    height: 247px;
}
#modules34 {
    top: 767px;
    left: 1420px;
    width: 430px;
    height: 247px;
}
#modules35 {
  top: 227px;
  left: 70px;
  width: 430px;
  height: 247px;
}
#modules36 {
  top: 227px;
  left: 580px;
  width: 430px;
  height: 247px;
}
#modules37 {
  top: 227px;
  left: 1420px;
  width: 430px;
  height: 247px;
}
</style>
